import { Suggest } from "@blueprintjs/select"
import React, { useCallback, useState } from "react"
// import useDoneTyping from "hooks/useDoneTyping";
import { MenuItem, Position } from "@blueprintjs/core"
import {
  AllUsersByGroupSelectorQuery,
  useAllUsersByGroupSelectorQuery,
} from "generated/graphql"
import CustomButton from "../Atoms/CustomButton"
import CustomFormGroup, { CustomFormGroupProps } from "../Atoms/CustomFormGroup"

type User = AllUsersByGroupSelectorQuery["usersByGroup"][0]
interface Props extends CustomFormGroupProps {
  onChange: (user: User) => void
  disabled?: boolean
}
const UserSuggest = ({ onChange, disabled, ...otherProps }: Props) => {
  const [user, setUser] = useState<User>()
  const [query, setQuery] = useState("")
  const { data } = useAllUsersByGroupSelectorQuery({
    variables: {
      query,
      first: 10,
      group: "*",
    },
  })

  const handleReset = useCallback(() => {
    setQuery("")
    setUser(null)
    onChange(null)
  }, [setQuery, setUser, onChange])

  const users = data?.usersByGroup ?? []
  return (
    <CustomFormGroup {...otherProps}>
      <Suggest
        disabled={disabled}
        selectedItem={user}
        onItemSelect={item => {
          setUser(item)
          onChange(item)
        }}
        inputValueRenderer={item => item?.fullName ?? ""}
        query={query}
        onQueryChange={query => {
          if (query.length === 0 || query.length >= 3) setQuery(query)
        }}
        items={users}
        itemRenderer={(item, { handleClick, modifiers }) => {
          return (
            <MenuItem
              icon="user"
              key={item?.id}
              text={item?.fullName}
              label={item?.number}
              onClick={handleClick}
              active={modifiers.active}
            />
          )
        }}
        popoverProps={{
          minimal: true,
          position: Position.BOTTOM_LEFT,
        }}
        inputProps={{
          fill: true,
          placeholder: "Search User",
          disabled,
          leftIcon: "search",
          rightElement: (
            <CustomButton
              disabled={disabled}
              minimal={true}
              icon="cross"
              intent="danger"
              onClick={handleReset}
            />
          ),
        }}
      />
    </CustomFormGroup>
  )
}

export default UserSuggest
